import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CrossIcon from '../../../../../assets/icons/secondary/Close.svg';
import {Text} from '../../../../../uikit/Text';
import {View} from '../../../../../uikit/View';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, membership, program} = contexts;

  const renderMessage = () => (
    <View style={{display: 'flex', flexDirection: 'column'}}>
      <Text
        variant="label.la"
        weight="semibold"
      >{`${i18n.t('shared:reason')}:`}</Text>
      <Text variant="label.la">{membership?.decline?.reason}</Text>
    </View>
  );

  return {
    avatar: actor?.avatar,
    avatarPlaceholder: actor?.name,
    icon: CrossIcon,
    iconGradient: 'danger',
    renderMessage: membership?.decline?.reason ? renderMessage : undefined,
    title: i18n.t('notifications:membership_declined_by_client.title', {
      actorName: actor?.name,
      programTitle: program?.title,
    }),
  };
};
